export default __webpack_public_path__ + "static/media/fv_sales.bab5958c.svg";